import React, { useState } from 'react';
import { Button, Form, Modal, Col, Row } from 'react-bootstrap';
import { useAuth } from '../contexts/AuthContext';
import { apiFetch } from '../services/apiService';

import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';

// Přidáváme props do komponenty
const ModalAddNews = ({ fetchAllNews }) => {

    const { logout } = useAuth();

    const [show, setShow] = useState(false);

    const handleClose = () => setShow(false);

    const handleShow = async () => {
        try {
            // Zde odešlete "testovací" požadavek na server
            await apiFetch('/api/general/validToken', { method: 'GET' });
            // Pokud je požadavek úspěšný (token je platný), otevřete modální okno
            setShow(true);
        } catch (error) {
            logout();
            window.location.href = '/login';
        }
    };

    const [title, setTitle] = useState('');
    const [content, setContent] = useState(''); // Pro CKEditor
    const [eventType, setEventType] = useState('');
    const [important, setImportant] = useState(false);

    const handleSubmit = async () => {
        // Vaše stávající logika pro odeslání dat
        try {
            await apiFetch('/api/news/addNews', {
                method: 'POST',
                body: JSON.stringify({ title, content, eventType, important }),
            });
            handleClose();
            await fetchAllNews(); // Zde aktualizujete seznam novinek
        } catch (error) {
            console.error('Chyba při pokusu přidat novinku:', error);
        }
    };

    return (
        <div className=''>
            <Button variant="outline-success" onClick={handleShow}>
                Přidat novinku
            </Button>

            <Modal show={show} onHide={handleClose}>
                <Modal.Header closeButton>
                    <Modal.Title>Novinka</Modal.Title>
                </Modal.Header>
                <Modal.Body>

                    <Form>
                        <Row className="mb-3">
                            <Form.Group as={Col} controlId="title">
                                <Form.Label>Nadpis</Form.Label>
                                <Form.Control
                                    type="text"
                                    placeholder="Nadpis novinky"
                                    value={title}
                                    onChange={e => setTitle(e.target.value)}
                                />
                            </Form.Group>
                        </Row>
                        <Row className="mb-3">
                            <Form.Group as={Col} controlId="content">
                                <Form.Label>Obsah</Form.Label>
                                <CKEditor
                                    editor={ClassicEditor}
                                    data={content}
                                    onChange={(event, editor) => {
                                        const data = editor.getData();
                                        setContent(data); // Aktualizace stavu s daty editoru
                                    }}
                                />
                            </Form.Group>
                        </Row>

                        <Form.Group className="mb-3" controlId="formGridState">
                            <Form.Label>Typ události</Form.Label>
                            <Form.Select
                                defaultValue="0" // Předpokládá se, že "0" je výchozí hodnota pro "Informace"
                                onChange={e => setEventType(Number(e.target.value))} // Převod hodnoty na číslo
                            >
                                <option value="0">Informace</option> 
                                <option value="1">Speciální akce</option> 
                                <option value="2">Zavřeno</option> 
                            </Form.Select>
                        </Form.Group>


                        <Form.Group className="mb-3" id="important">
                            <Form.Check
                                type="checkbox"
                                label="Akutní"
                                checked={important}
                                onChange={e => setImportant(e.target.checked)} />
                        </Form.Group>

                    </Form>

                </Modal.Body>
                <Modal.Footer className='d-flex justify-content-between'>
                    <Button variant="outline-secondary" onClick={handleClose}>
                        Zrušit
                    </Button>
                    <Button variant="outline-success" onClick={handleSubmit}>
                        Uložit
                    </Button>
                </Modal.Footer>
            </Modal>
        </div>
    );
};

export default ModalAddNews;